import React from 'react';
import PropTypes from 'prop-types';
import styles from './Section.module.scss';
import { Button } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HelpModal from './HelpModal';

const Section = ({ header, actions, onSelect, icon, policy }) => {
	return (
		<div className={styles.container}>
			<FontAwesomeIcon className={styles.icon} icon={icon} />
			<div className={styles.header}>{header}</div>

			<div className={styles.actions}>
				{actions && policy &&
					actions
						.filter((a) => !a.disabled)
						.map((action, i) => {
							if (action.isError) {
								return (
									<HelpModal
										key={i}
										trigger={
											<Button  primary className={styles.action} disabled={action.disabled}>
												{action.title}
											</Button>
										}
										title={action.header}
										message={action.message}
										agency={policy.agency}
										policyNumber={policy.policyNumber}
									/>
								);
							} else {
								return (
									<Button id={action.id} key={i} primary className={styles.action} onClick={() => onSelect(action)} disabled={action.disabled}>
										{action.title}
									</Button>
								);
							}
						})}
			</div>
		</div>
	);
};

Section.propTypes = {
	header: PropTypes.string.isRequired,
	icon: PropTypes.any.isRequired,
	actions: PropTypes.array.isRequired,
	onSelect: PropTypes.func.isRequired,
};

export default Section;
